import { Sparkles } from "lucide-react";

export const Marquee = ({ items }) => (
  <div
    data-testid="trust-marquee"
    className="relative overflow-hidden bg-primary py-7 border-y border-white/10"
  >
    <div className="flex w-max animate-[marquee_30s_linear_infinite] hover:[animation-play-state:paused]">
      {[...items, ...items].map((it, i) => (
        <div key={i} className="flex items-center shrink-0">
          <span className="mx-10 font-heading font-extrabold text-2xl md:text-4xl tracking-tight text-white/90">
            {it}
          </span>
          <Sparkles className="h-6 w-6 text-accent shrink-0" />
        </div>
      ))}
    </div>
  </div>
);
